import ongStaticData from '../../services/static/ongs.data.static';
import DEFAULT_ONG from '../../services/static/ongs.data.default';
import { ONG_CARD_STATES } from '../constants.solidarity';

class Ong {
  constructor(data) {
    this.code = data.code;
    this.name = data.literal;
    this.maxContribution = data.maxContribution || 1;
    this.minContribution = data.minContribution || 1;
    this.details = {};
    this.contribution = {};
    this.cardState = ONG_CARD_STATES.INITIAL;
  }

  getStaticData() {
    let data = ongStaticData[this.code];

    if (data === undefined) {
      data = ongStaticData.DEFAULT;
    }

    return data;
  }

  setDetails(staticData) {
    const isDefaultOng = staticData.code === DEFAULT_ONG.code;

    if (isDefaultOng) return;

    this.details = new OngDetails(staticData);
  }

  setContribution(contributions) {
    const contribution = contributions.filter((contribution) => {
      return contribution.entity === this.code;
    });
    const hasNotContribution = contribution.length === 0;

    if (hasNotContribution) return;

    this.contribution = new OngContribution(contribution[0]);
    this.cardState = ONG_CARD_STATES.CONTRIBUTION;
  }

  setState(cardState) {
    this.cardState = cardState;

    if (cardState === ONG_CARD_STATES.INITIAL) {
      this.contribution.amount = 0;
    }
  }
}

class OngDetails  {
  constructor(details) {
    this.imgDetails = details.imgDetails;
    this.link = details.link;
    this.linkText = details.linkText;
    this.moreInformation = details.moreInformation;
    this.description = details.description;
  }
}

class OngContribution  {
  constructor(contribution) {
    this.amount = contribution.amount;
    this.startDate = contribution.startDate;
    this.dischargeDate = contribution.dischargeDate;
  }
}

export default Ong;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/common/domain/models/ong.model.js